import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Graphics } from '@inlet/react-pixi';
import { useMemo } from 'react';
import { useFindQueue } from 'components/powerFlowShared/hooks/useFindQueue';
import { usePixiBadge } from 'components/powerFlowShared/hooks/usePixiBadge';
import { flowNodeColor } from 'fable/flowEditor';
import { Text } from 'flow-builder/node/text';
import { TextContent } from 'flow-builder/node/textContent';
import { TextEllipsis } from 'flow-builder/node/textEllipsis';
import { hexStringToNumber } from 'flow-builder/renderers/common/colors';
import { VoicemailModal } from '../../modals/voicemail';
import { useAnnouncementName } from './callback';
const updateConnection = (node, _connection, connectionId) => {
    const payload = Object.assign({}, node.payload);
    if (payload === null || payload === void 0 ? void 0 : payload.queue) {
        payload.queue = Object.assign(Object.assign({}, payload.queue), { value: connectionId });
    }
    return Object.assign(Object.assign({}, node), { payload });
};
export const VoicemailNodeAttributes = {
    iconName: 'conversations',
    label: 'Voicemail',
    helpText: 'Record or upload a voicemail asking your customers to leave a message if no agents are available.',
    color: hexStringToNumber(flowNodeColor.green),
    translatePayload: () => [],
    updateConnection,
    NodeContent: VoicemailNode,
    ActionModal: VoicemailModal,
};
export function VoicemailNode({ node, context, }) {
    const { extraData } = context;
    const { payload } = node;
    const announcement = useAnnouncementName(payload.announcement, extraData);
    const queue = useFindQueue(payload.queue, extraData);
    const drawArchivedBadge = usePixiBadge({
        text: 'Archived',
        variant: 'error',
        offset: { x: 0, y: 52 },
    });
    return (_jsx(TextContent, { children: useMemo(() => {
            var _a, _b, _c;
            return (_jsxs(_Fragment, { children: [_jsxs(TextEllipsis, { children: [_jsx(Text, { weight: "normal", text: "Announcement" }), _jsx(Text, { weight: "semibold", text: announcement })] }), _jsxs(TextEllipsis, Object.assign({ offset: { y: 5, x: 0 } }, { children: [_jsx(Text, { weight: "normal", text: "Queue" }), _jsx(Text, { weight: "semibold", text: (_c = (_a = queue === null || queue === void 0 ? void 0 : queue.name) !== null && _a !== void 0 ? _a : (_b = payload.queue) === null || _b === void 0 ? void 0 : _b.label) !== null && _c !== void 0 ? _c : 'No queue selected' })] })), (queue === null || queue === void 0 ? void 0 : queue.is_archived) && _jsx(Graphics, { draw: drawArchivedBadge })] }));
        }, [announcement, drawArchivedBadge, payload.queue, queue]) }));
}
